import { render, staticRenderFns } from "./ChiTietTinTuc.vue?vue&type=template&id=6da9d964&scoped=true&"
import script from "./ChiTietTinTuc.vue?vue&type=script&lang=js&"
export * from "./ChiTietTinTuc.vue?vue&type=script&lang=js&"
import style0 from "./ChiTietTinTuc.vue?vue&type=style&index=0&id=6da9d964&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da9d964",
  null
  
)

export default component.exports